import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export const fetchScheduleById = (id: string | null) => {
  if (!id) return;
  const newEndpoints = endpoints.scheduling.scheduleById.replace('{id}', id);
  return http().get(newEndpoints);
};

export function useFetchScheduleById(id: string | null, options?: any): UseQueryResult<any> {
  return useQuery({ queryKey: ['fetchScheduleById', id], queryFn: () => fetchScheduleById(id!), ...options });
}
